export const globalObj = (typeof global !== 'undefined' ? global : typeof window !== 'undefined' ? window : this);
export { globalObj as global };
//# sourceMappingURL=global.js.map